var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPatientG(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 315,
    height: 250,
    viewBox: "0 0 315 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#DEE2E6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.5 118C54.116 118 66 106.34 66 92S54.116 66 39.5 66 13 77.66 13 92s11.884 26 26.5 26zm236.5 0c14.34 0 26-11.66 26-26s-11.66-26-26-26-26 11.66-26 26 11.66 26 26 26zm12.75 13h-26.251c-7.22 0-13.741 2.884-18.499 7.556 16.53 8.978 28.26 25.188 30.804 44.444h27.07c7.26 0 13.126-5.81 13.126-13v-13c0-14.34-11.772-26-26.25-26zm-131.25-7c34.542 0 62.5-27.734 62.5-62S192.042 0 157.5 0 95 27.734 95 62s27.958 62 62.5 62zm43 18h-4.647c-11.646 5.625-24.58 9-38.353 9-13.773 0-26.651-3.375-38.353-9H114.5C78.89 142 50 171.025 50 206.8V223c0 14.906 12.038 27 26.875 27h161.25C252.962 250 265 237.906 265 223v-16.2c0-35.775-28.89-64.8-64.5-64.8zM71 138.556C66.242 133.884 59.72 131 52.501 131h-26.25C11.77 131 0 142.66 0 157v13c0 7.19 5.865 13 13.125 13h27.03C42.74 163.744 54.47 147.534 71 138.556z",
    transform: "translate(-1017 -414) translate(980 330) translate(37 84)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPatientG);
export default __webpack_public_path__ + "static/media/user-patient-g.9749281cef661b4d5f53a296b9c3000f.svg";
export { ForwardRef as ReactComponent };